import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/UI/Buttons/Button/Button';
import styles from '../SubscriptionDowngrade.module.css';

const CancellationSection = ({ handleCancelSubscription, loading, to }) => {
  const { t } = useTranslation();
  
  return (
    <div className={styles.cancellationSection}>
      <p>{t('subscription.cancel_question')}</p>
      <Button
        className={styles.cancelButton}
        onClick={handleCancelSubscription}
        to={to}
        disabled={loading}
      >
        {loading ? t('common.processing') : t('subscription.proceed_to_cancel')}
      </Button>
    </div>
  );
};

export default CancellationSection;
